export default __webpack_public_path__ + "static/media/trade-route-concept-animation-major-location-destination-SBV-300316368-HD.557671b2.mp4";